<div
  (click)="!disabled() && toggle(showExpandedSignal)"
  [class.cursor-pointer]="!disabled()"
  [class.cursor-not-allowed]="disabled()"
>
  <mat-icon [class.disabled]="disabled()" class="expand-collapse-icon">{{ showExpandedSignal() ? "keyboard_arrow_up" : "keyboard_arrow_down" }}</mat-icon>
  <div [class.disabled]="disabled()" class="expand-collapse-words">{{ showExpandedSignal() ? "&nbsp;Less" : "More" }}</div>

</div>